export let GITHUB_URL = "https://github.com/fisher60";
export let LINKEDIN_URL = "https://www.linkedin.com/in/kylerr/";
